import { Button } from "@/components/ui/button";

interface PaginationControlsProps {
  // Content pagination (for large documents)
  contentPage: number;
  setContentPage: (page: number) => void;
  totalContentPages: number;
  needsPagination: (content: string | null) => boolean;
  currentContent: string | null;
  
  // Document parts pagination (for multi-part PDFs)
  totalParts?: number | null;
  currentPart: number;
  setCurrentPart: (part: number) => void;
}

export const PaginationControls = ({
  contentPage,
  setContentPage,
  totalContentPages,
  needsPagination,
  currentContent,
  totalParts,
  currentPart,
  setCurrentPart,
}: PaginationControlsProps) => {
  
  return (
    <>
      {/* Content pagination for large documents */}
      {needsPagination(currentContent) && (
        <div className="flex items-center justify-center px-4 py-2 border-t">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              disabled={contentPage === 1}
              onClick={() => setContentPage(Math.max(1, contentPage - 1))}
              className="h-7 px-2 text-xs"
            >
              ←
            </Button>
            <span className="text-xs text-gray-600 px-2">
              {contentPage} / {totalContentPages}
            </span>
            <Button
              variant="ghost"
              size="sm"
              disabled={contentPage === totalContentPages}
              onClick={() => setContentPage(Math.min(totalContentPages, contentPage + 1))}
              className="h-7 px-2 text-xs"
            >
              →
            </Button>
          </div>
        </div>
      )}

      {/* Document parts pagination for multi-part PDFs */}
      {totalParts && totalParts > 1 && (
        <div className="flex items-center justify-center px-4 py-2 border-t bg-slate-50">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              disabled={currentPart === 1}
              onClick={() => {
                setCurrentPart(Math.max(1, currentPart - 1));
              }}
              className="h-7 px-2 text-xs"
            >
              ←
            </Button>
            <span className="text-xs text-gray-600 px-2 font-medium">
              Part {currentPart} / {totalParts}
            </span>
            <Button
              variant="ghost"
              size="sm"
              disabled={currentPart === totalParts}
              onClick={() => {
                setCurrentPart(Math.min(totalParts || 1, currentPart + 1));
              }}
              className="h-7 px-2 text-xs"
            >
              →
            </Button>
          </div>
        </div>
      )}
    </>
  );
};